import { z } from "zod";

const translationPath = "page.4uMarCom.automationRules.marcom_message.errors.";

const ticketChannelStepSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.string().nullish(),
  },
  { invalid_type_error: translationPath + "ticket_channel_step" },
);

const ticketChannelSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.string().nullish(),
  },
  { invalid_type_error: translationPath + "ticket_channel" },
);

const ticketAutomationReceivedRuleSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.union([z.string(), z.number()]).optional(),
  },
  { invalid_type_error: translationPath + "ticket_automation_received_rule" },
);

export const messageSchema = z
  .object({
    id: z.string().optional(),
    priority: z.string().optional(),
    enable: z.boolean(),
    name: z.string().min(1, translationPath + "name"),
    startDate: z.date({
      invalid_type_error: translationPath + "start_date",
    }),
    endDate: z.date({ invalid_type_error: translationPath + "end_date" }),
    isMoveHumanAttendant: z.boolean(),
    finishedFromStart: z.boolean(),
    ticketChannelStep: ticketChannelStepSchema.nullish(),
    ticketChannel: ticketChannelSchema.nullish(),
    ticketAutomationReceivedRule: ticketAutomationReceivedRuleSchema.nullish(),
    moveTicketWhenNotIdentified: z.boolean(),
    ticketChannelStepWhenNotIdentified: ticketChannelStepSchema.nullish(),
    ticketChannelWhenNotIdentified: ticketChannelSchema.nullish(),
  })
  .superRefine((val, ctx) => {
    if (val.finishedFromStart && !val.ticketChannelStep) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: translationPath + "ticket_channel_step",
        path: ["ticketChannelStep"],
      });
    }
    if (val.finishedFromStart && !val.ticketChannel) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: translationPath + "ticket_channel",
        path: ["ticketChannel"],
      });
    }
    if (
      val.finishedFromStart &&
      val.ticketAutomationReceivedRule &&
      val.moveTicketWhenNotIdentified &&
      !val.ticketChannelWhenNotIdentified
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: translationPath + "ticket_channel_when_not_identified",
        path: ["ticketChannelWhenNotIdentified"],
      });
    }
    if (
      val.finishedFromStart &&
      val.ticketAutomationReceivedRule &&
      val.moveTicketWhenNotIdentified &&
      !val.ticketChannelStepWhenNotIdentified
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: translationPath + "ticket_channel_step_when_not_identified",
        path: ["ticketChannelStepWhenNotIdentified"],
      });
    }
  });
export type TMessageForm = z.infer<typeof messageSchema>;
